import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach token from localStorage as a fallback (works alongside cookies)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jms_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // AP-049 · Multi-tenant demo mode — Master users select the active company
  // via the header. The backend middleware validates the tenant against the
  // caller's role, so this header is safe to send on every request.
  const tenant = localStorage.getItem("jms_tenant");
  if (tenant) {
    config.headers["X-Tenant-Id"] = tenant;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Erro inesperado";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
